import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import Config from "../../Configs";
import { ApiResponse, ApiError } from "../../Models";
import LogService from "../LogService";
import { IHttpService } from "./IHttpService";
import store from "../../Redux/Store";
import GeneralState from "../../Redux/States/General";
export default class BaseHttpService implements IHttpService {
    private _service: AxiosInstance;
    private _headers: any;

    constructor() {
        this._service = axios.create({
            baseURL: Config.baseApi,
            withCredentials: true,
        });
        this._service.interceptors.response.use(this.handleSuccess, this.handleError);
        this._headers = {};
    }

    async get<T>(path: string): Promise<ApiResponse<T>> {
        const response = await this.sendRequest<T>("GET", path);
        return <ApiResponse<T>>response;
    }

    async post<T>(path: string, body: any): Promise<ApiResponse<T>> {
        const response = await this.sendRequest<T>("POST", path, body);
        return <ApiResponse<T>>response;
    }

    async patch<T>(path: string, body: any): Promise<ApiResponse<T>> {
        const response = await this.sendRequest<T>("PATCH", path, body);
        return <ApiResponse<T>>response;
    }

    async delete<T>(path: string): Promise<ApiResponse<T>> {
        const response = await this.sendRequest<T>("DELETE", path);
        return <ApiResponse<T>>response;
    }

    setUserIdentifier(userIdentifier: string) {
        this._headers["User-Identifier"] = userIdentifier;
    }

    private handleSuccess = (response: AxiosResponse<any>) => {
        return response.data;
    };

    private handleError = (error: any) => {
        const { dispatch } = store;

        if (error?.response?.data) {
            if (!(error.response.request.responseURL && error.response.request.responseURL.includes("auth"))) {
                const errorsModel: ApiError = {
                    showGeneralErrorModal: true,
                    statusCode: error.response.data.statusCode,
                    errorMessage: error.response.data.error,
                    serviceName: error.response.request.responseURL,
                };
                dispatch(GeneralState.Actions.setApiErrors(errorsModel));
            } else {
                const errorsModel: ApiError = {
                    showGeneralErrorModal: false,
                    statusCode: 0,
                    errorMessage: "",
                    serviceName: "",
                };
                dispatch(GeneralState.Actions.setApiErrors(errorsModel));
            }

            return Promise.resolve(error.response.data);
        } else {
            const errorResponse: ApiResponse<any> = {
                statusCode: error?.response?.status || 400,
                data: null,
            };
            LogService.logError(errorResponse);
            return Promise.resolve(errorResponse);
        }
    };

    private async sendRequest<T>(method: "GET" | "POST" | "PATCH" | "DELETE", path: string, payload?: any): Promise<any> {
        return await this._service.request<ApiResponse<T>>(this.getConfigurations(method, path, payload));
    }

    private getConfigurations(method: "GET" | "POST" | "PATCH" | "DELETE", path: string, payload?: any): AxiosRequestConfig {
        return {
            method: method,
            url: path,
            responseType: "json",
            data: payload,
            headers: this._headers,
        };
    }
}
